import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class RiskAndThreat extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get icon() {
    return get(this, '_ikonka.value[0].url', '');
  }

  get header() {
    return get(this, '_naglowek.value', '');
  }

  get shortText() {
    return get(this, '_tekst_krotki.value', '');
  }

  get longText() {
    return get(this, '_tekst_dlugi.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/RiskAndThreat.js